import { getFetch } from "../../utils/fetch";

async function getJensCodes(term) {
  const data = await getFetch(`/ReportWeb/JensCodes?term=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { getJensCodes };
